import React from "react";
import {useSelector} from "react-redux";
import {selectIsAuthenticated} from "./feature/auth/authSlice";
import LoginPage from "./components/LoginPage";
import MainPage from "./components/MainPage";
import {ToastContainer} from "react-toastify";

export default function App() {
  const isAuthed = useSelector(selectIsAuthenticated);

  return (
    <>
      <ToastContainer position="top-left" newestOnTop={true} closeOnClick autoClose={20000}/>
      {isAuthed ? <MainPage/> : <LoginPage/>}
    </>
  );
}
